import React from "react";
import { createPortal } from "react-dom";
import "./WaitOverlay.scss";

/**
 * 대기 중 오버레이
 * @param {boolean} show
 * @param {string} text
 * @param {string} [subText]
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} local — true면 부모 relative 영역 안
 */
function WaitOverlay({
  show,
  text = "잠시만 기다려 주세요",
  subText,
  size = "md",
  local = false,
}) {
  if (!show) return null;

  const node = (
    <div
      className={`wait-overlay wait-overlay--${size}${
        local ? " wait-overlay--local" : ""
      }`}
      role="alert"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="wait-overlay__card">
        <span className="wait-overlay__spinner" aria-hidden />
        {text ? <p className="wait-overlay__text">{text}</p> : null}
        {subText ? <p className="wait-overlay__sub">{subText}</p> : null}
      </div>
    </div>
  );

  if (local) return node;
  if (typeof document === "undefined") return null;
  return createPortal(node, document.body);
}

export default React.memo(WaitOverlay);
